import { Drawer } from 'antd';
import { Button } from 'components/Button';
import FilterInput from 'components/Form/filterInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';


const SalaryFilterDrawer = ({   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty

}) => {
  const [placement] = useState('right');  

const [userOption, setUserOption] = useState([]);


useEffect(()=>{
    let _userList = []
    let _users = _userList.map(item=> {
        return{
            label: item.first_name,
            value: item.user_id
        }
    })    
    setUserOption(_users)   
},[])



const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);

  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Filters"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        footer={
          <div>
            {filters.some(filter => filter.value && filter.key !== "search") && (
              <Button
                label="Clear All"
                onClick={handleClearAll}
                className="btn btn-link w-100 mb-2 p-0"
                style={{ color: "var(--brand-text-muted)", fontWeight: 600 }}
              />
            )}
            <Button label="Apply Filter" loading={filterLoading} disabled={filterLoading || !isFilterDirty} onClick={handleApplyFilter} className="btn btn-primary w-100" style={{ borderRadius: "8px" }} />
          </div>
        }
      >
        <div className='col-12 mb-3' >
          <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "user")}} optionLabel={"label"} optionValue={'value'} options={userOption}  value={setFilterValue("user")} placeholder={"Select User"}/>
        </div>

        <div className='col-12 mb-3' >
       
          <FilterInput  
             defaultValue={setInputValue("email")} 
              onChange={e=>{handleInputChange(e.target.value, "email", true)}} 
              id="email"
              label={"Email"}
            />

        </div>        

      </Drawer>
    </>
  );
};
export default SalaryFilterDrawer;